@use '~/theme/theme' as *;

/* Align the checkbox with the vertical middle of the adjacent (medium) select input.
   The select stacks: label (caption, line-height 18px) + field gap (spacing(0.5) = 4px) + input.
   Offsetting 22px past the field top lands at the input's top, then a box matching the input
   height (38px) with centered content lines the checkbox up with the input's middle. */
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 38px;
  margin-top: calc(var(--line-height-caption) + #{spacing(0.5)});
}
